module.exports = __webpack_public_path__ + "static/favicon-1f4214c3b6152ec2227552ab52e8f62d.ico";